import React from 'react'
import { createContainer } from '@dbk-legacy/muster/react';
import  Spinner from '@dbk/ui-spinner';
import TradeSecurityPriceChart from './trade-security-price-chart';
import NoDataChart from '../../../../../components/common/no-data-chart';
import { getChartData } from './trade-utils';

const NUM_DAYS = 5;

class TradePriceHistoryChart extends React.PureComponent {

  render () {
    const {
      data,
      messages
    } = this.props;

    // used same logic with the existing chart(price-history-chart) for apac

    const validData = data.filter(({ price }) => price.value !== null);

    const priceChartData = getChartData(validData, NUM_DAYS);

    if(priceChartData.length < 2) {
      return (<NoDataChart
        key="no-data"
        messages={messages}
      />);
    }

    return (
      <TradeSecurityPriceChart
        langCode={this.props.auth.langCode}
        chartData={priceChartData}
        currencyCode={this.props.row.positionCurrency} />
    )
  }
}

export default createContainer({
  $queries: {
    auth: {
      langCode: true
    }
  }
})(TradePriceHistoryChart)
